import moment from "moment";
import { MESSAGE } from "@/model/Message";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends";
import { Uketsuke } from "@/model/Uketsuke";
import { CALENDAR_YEAR } from "@/model/CALENDAR_YEAR";
import { MAXSOUKOUKM, MAXSOUKOUMILE } from "@/model/MAXSOUKOUKM";

// export class Utils {
// export default class extends Vue {
export class Utils {
  // UUIDは認証情報ではなく、HTTP/WebSocketの送信元タブを識別するための値。
  // localStorageへ保存すると複製タブ間で共有され、他タブの更新通知まで
  // 自タブ起因として無視してしまうため、JavaScript実行コンテキストごとに保持する。
  private static shakenUuids: { [mode: string]: string } = {};
  formatDate(
    strDate: string,
    outputFormat: string,
    inputFormat: string = "YYYYMMDD"
  ): string {
    return moment(strDate, inputFormat).format(outputFormat);
  }
  
  getDate(strDate: string,) {
    return moment(strDate, "YYYYMMDD").toDate();
  }
  
  getFullDate(strDate: string, format: string): string {
    const date = moment(strDate, format);
    const year = date.format("YYYY");
    let dateOutput = "";
  
    if (format.indexOf("Y") > -1) {
      let era = this.findEra(date);
      if (era.Char) {
        let jaYear = Number(year) - era.Diff;
        dateOutput += era.YearNm + jaYear + "年";
      }
    }
    if (format.indexOf("M") > -1) {
      dateOutput += date.format("M月");
    }
    if (format.indexOf("D") > -1) {
      dateOutput += date.format("D日");
    }
  
    return dateOutput;
  }
  
  findEra(date: any) {
    if (date instanceof Date) {
      date = moment(date);
    }
    for (let i = CALENDAR_YEAR.length - 1; i > 0; i--) {
      if (date.isSameOrAfter(moment(CALENDAR_YEAR[i].Start, "YYYYMMDD"))) {
        return CALENDAR_YEAR[i];
      }
    }
    return CALENDAR_YEAR[0];
  }
  
  getJapanDate(strDate: string, format: string): string {
    if (strDate == "") {
      return "";
    }
    const date = moment(strDate, format);
    const year = date.format("YYYY");
    let era = this.findEra(date);
    if (era.Char) {
      let jaYear = Number(year) - era.Diff;
      let dateOutput = era.Char + this.padNumber(jaYear.toString(), 2);
      if (format.length > 4) {
        let outputformat = format
          .replace("YYYY", "")
          .replace("MM", "/MM")
          .replace("DD", "/DD");
        dateOutput += date.format(outputformat);
      }
      return dateOutput;
    }
    return "";
  }
  
  getNow(format: string): string {
    return moment().format(format);
  }
  
  dateToFormat(date: Date, format: string): string {
    return moment(date).format(format);
  }
  
  setSelect(element: HTMLInputElement) {
    element.select();
  }
  
  focusNext(index: number, id?: string) {
    let nextEl: any;
    if (id) {
      nextEl = document.getElementById(id);
    } else if (index != null) {
      nextEl = document.querySelector(`[index='${index + 1}'`);
      if (!nextEl) {
        nextEl = document.querySelector(`[index='${index + 2}'`);
      }
    }
    if (nextEl) {
      setTimeout(() => {
        nextEl.focus();
      }, 200);
    }
  }
  
  padNumber(input: string, n: number): string {
    let s = input;
    while (s.length < n) {
      s = "0" + s;
    }
    return s;
  }
  
  getNumberThousandSeparate(input: number): string {
    return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  
  getUTF8Length(str: string, maxbyte: number) {
    if (str === "" || str == null) {
      return { count: 0, strCount: 0 };
    }
    let ch = null;
    let count = 0;
    let countTxt = 0;
    for (let i = 0; i < str.length; i++) {
      ch = str.charCodeAt(i);
    
      if (
        (ch >= 0x0 && ch < 0x81) ||
        ch === 0xf8f0 ||
        (ch >= 0xff61 && ch < 0xffa0) ||
        (ch >= 0xf8f1 && ch < 0xf8f4)
      ) {
        count += 1;
      } else {
        count += 2;
      }
    
      if (count <= maxbyte) {
        countTxt++;
      }
    }
  
    return { count: count, strCount: countTxt };
  }
  
  removeLeadingZero(str: string) {
    return str.replace(/^0+/g, "");
  }
  
  toASCII(chars: string) {
    let ascii = "";
    chars = chars.replace("。", ".");
    for (let i = 0, l = chars.length; i < l; i++) {
      let c = chars[i].charCodeAt(0);
      if (c >= 0xff00 && c <= 0xffef) {
        c = 0xff & (c + 0x20);
      }
      ascii += String.fromCharCode(c);
    }
  
    return ascii;
  }
  
  getDurationMonth(startDate: string, endDate: string) {
    if (startDate && endDate) {
      const format = "YYYYMMDD";
      let start = moment(startDate, format);
      let end = moment(endDate, format);
      let duration = moment.duration(start.diff(end));
      return Math.ceil(duration.asMonths());
    }
    return 0;
  }
  
  getWSBody(frame: any) {
    return JSON.parse(frame.body);
  }
  
  getWSData(frame: any) {
    const body = this.getWSBody(frame);
    if (body && Object.prototype.hasOwnProperty.call(body, "data")) {
      return body.data;
    }
    return body;
  }

  getShakenUuidMode(isUserMode?: boolean) {
    const isUser = typeof isUserMode === "boolean"
      ? isUserMode
      : window.location.pathname.indexOf("/user") === 0;
    return isUser ? "user" : "factory";
  }

  getShakenUuid(isUserMode?: boolean) {
    const mode = this.getShakenUuidMode(isUserMode);
    if (!Utils.shakenUuids[mode]) {
      Utils.shakenUuids[mode] = this.createShakenUuid();
    }
    return Utils.shakenUuids[mode];
  }

  setShakenUuid(uuid: string, isUserMode?: boolean) {
    if (uuid) {
      Utils.shakenUuids[this.getShakenUuidMode(isUserMode)] = uuid;
    }
  }

  isSelfSocket(frame: any, isUserMode?: boolean) {
    const body = this.getWSBody(frame);
    const localUuid = this.getShakenUuid(isUserMode);
    return !!(body && body.originUuid && localUuid && body.originUuid === localUuid);
  }

  private createShakenUuid(): string {
    const randomValues = new Uint32Array(4);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(randomValues);
      return Array.prototype.map.call(randomValues, (value: number) => value.toString(16)).join("-");
    }
    return Date.now().toString(16) + "-" + Math.random().toString(16).slice(2);
  }

  removeNonEng(str: string) {
    return str.replace(/[^A-Za-z\d]/g, "");
  }
  
  getHttpErrorMessage(error: {
    status: number;
    rsltComment: string;
  }) {
    if (error.status == 204) {
      return MESSAGE.NoData;
    } else if (error.status < 500 && error.rsltComment) {
      return error.rsltComment;
    } else {
      return MESSAGE.SystemError;
    }
  }
  
  deepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }
  
  calSoukouAvg(soukouKm: number, sknUketsukeExtends: SknUketsukeExtends, uketsuke: Uketsuke) {
    let avg = 0;
    if (soukouKm > 0 &&
      sknUketsukeExtends &&
      uketsuke.workPlansYmd &&
      sknUketsukeExtends.zenkaiSoukouYmd
    ) {
      let month = this.getDurationMonth(
        uketsuke.workPlansYmd,
        sknUketsukeExtends.zenkaiSoukouYmd
      );
      if (month > 0) {
        let lastSoukouKm = 0;
        if (sknUketsukeExtends.zenkaiSoukouKm) {
          lastSoukouKm = Number(sknUketsukeExtends.zenkaiSoukouKm);
        }
        avg = Math.ceil((soukouKm - lastSoukouKm) / month);
      }
    }
    return avg;
  }
  
  calSoukouMileAvg(soukouMile: number, sknUketsukeExtends: SknUketsukeExtends, uketsuke: Uketsuke) {
    let avg = 0;
    if (soukouMile > 0 &&
      sknUketsukeExtends &&
      uketsuke.workPlansYmd &&
      sknUketsukeExtends.zenkaiSoukouYmd
    ) {
      let month = this.getDurationMonth(
        uketsuke.workPlansYmd,
        sknUketsukeExtends.zenkaiSoukouYmd
      );
      if (month > 0) {
        let lastSoukouMile = 0;
        if (sknUketsukeExtends.zenkaiSoukouMile) {
          lastSoukouMile = Number(sknUketsukeExtends.zenkaiSoukouMile);
        }
        avg = Math.ceil((soukouMile - lastSoukouMile) / month);
      }
    }
    return avg;
  }
  
  checkLimitSoukou(soukou: number, unitKbn: any) {
    if (unitKbn === 2) {
      return soukou > MAXSOUKOUMILE;
    } else {
      return soukou > MAXSOUKOUKM;
    }
  }
  msgExceedSoukou(unitKbn: any) {
    const max = unitKbn === 2 ? MAXSOUKOUMILE : MAXSOUKOUKM;
    const maxStr = this.getNumberThousandSeparate(max);
    const unit = unitKbn === 2 ? "mile" : "km";
    return `走行距離は、${maxStr}${unit}以内で入力してください。`;
  }
}

